export default {
    table: {
        titles: {
            reserved_by: 'Забронировано',
            received: 'Получено',
            offer: 'Услуга',
            location: 'Местоположение',
            created_date: 'Дата создания',
            scheduled_for: 'Запланировано на',
            status: 'Статус',
        },
    },
    other: {
        add_to_calendar: 'Добавить в календарь',
        tooltip:
            'Нажав на эту кнопку, бронирование будет добавлено в ваш календарь Apple или Google. Адрес электронной почты человека, который сделал бронирование, будет автоматически скопирован в буфер обмена, чтобы вы могли легко добавить пользователя или гостя в событие.',
    },
}
